import { getExplorerUpsertDigitalDossierLegalRepresentantInformationDto } from '@bcba/validators';

export const {
  UpsertExplorerDigitalDossierLegalRepresentantInformationDto:
    _UpsertExplorerDigitalDossierLegalRepresentantInformationDto,
} = getExplorerUpsertDigitalDossierLegalRepresentantInformationDto();

export class UpsertExplorerDigitalDossierLegalRepresentantInformationDto extends _UpsertExplorerDigitalDossierLegalRepresentantInformationDto {}
